const EXPERIENCE_BOOKING_CHANGE_EVENT = 'experience-booking:change';

export default class ExperienceBookingConfigurator {
  constructor(root) {
    this.root = root;
    this.root.addEventListener('change', () => this.notifyChange());
    this.root.addEventListener('input', () => this.notifyChange());
  }

  readState() {
    const getValue = (name) => {
      const input = this.root.querySelector(`[name="${name}"]`);

      return input ? input.value : '';
    };
    const getCheckedValue = (name) => {
      const input = this.root.querySelector(`[name="${name}"]:checked`);

      return input ? input.value : '';
    };
    let extras = {};

    try {
      extras = JSON.parse(getValue('extras') || '{}');
    } catch (error) {
      extras = {};
    }

    return {
      visitors: {
        adults: Number(getValue('seats_adult')) || 0,
        children: Number(getValue('seats_child')) || 0,
        infants: Number(getValue('seats_infant')) || 0,
      },
      languageId: getCheckedValue('lang_id') || getValue('lang_id') || getCheckedValue('main_lang_id'),
      date: getValue('date'),
      slotId: getValue('slot_id'),
      slot: getValue('slot'),
      bookingAuto: getValue('booking_auto'),
      departurePointId: getCheckedValue('departure_point'),
      extras,
      contact: {
        firstname: getValue('firstname'),
        lastname: getValue('lastname'),
        email: getValue('mail'),
        phone: getValue('phone'),
        country: getValue('country'),
        birthDay: getValue('dob_day'),
        birthMonth: getValue('dob_month'),
        birthYear: getValue('dob_year'),
        acceptsHostEmailCommunication: getCheckedValue('accepts_host_email_communication') === '1',
      },
    };
  }

  isComplete(requireContact = true) {
    const state = this.readState();
    const adultsInput = this.root.querySelector('[name="seats_adult"]');
    const visitorsCount = state.visitors.adults + state.visitors.children + state.visitors.infants;

    if (
      !adultsInput
      || !adultsInput.validity.valid
      || state.visitors.adults < Number(adultsInput.min || 0)
      || visitorsCount < 1
    ) {
      return false;
    }

    if (!state.languageId) {
      return false;
    }

    if (!this.root.hasAttribute('data-is-ticket') && (!state.date || !state.slotId || !state.slot)) {
      return false;
    }

    if (this.root.hasAttribute('data-departure-points-to-choose') && !state.departurePointId) {
      return false;
    }

    if (!requireContact) {
      return true;
    }

    return Array.from(this.root.querySelectorAll('[data-experience-booking-contact] [required]'))
      .every((input) => input.value !== '');
  }

  notifyChange() {
    this.root.dispatchEvent(new CustomEvent(EXPERIENCE_BOOKING_CHANGE_EVENT, {
      detail: this.readState(),
    }));
  }
}

export { EXPERIENCE_BOOKING_CHANGE_EVENT };
